/*import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false

new Vue({
  render: h => h(App)
}).$mount('#app')


// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
*/

import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueResource from 'vue-resource'
import fly from "flyio"
import '../static/css/qlcss.css' /*引入公共样式*/
import  'video.js/dist/video-js.min.css'


//import '../static/css/video-js.css' /*引入公共样式*/
Vue.use(VueResource)
Vue.use(ElementUI)
Vue.prototype.$fly = fly;
Vue.config.productionTip = false

new Vue({
    router,
    render: h => h(App)
}).$mount('#app')
